import type { FaireProductEntity } from "../../entity_types/product";

export const p_yrywfwvtcd: FaireProductEntity = {
  token: "p_yrywfwvtcd",
  type: "product",
  name: "I Love You as Big as Arkansas",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl: "https://cdn.faire.com/fastly/f37c4d1b75edd7a62a1ce63e2c52af5b1fecb192ae497f1fce2cb48af16ff3c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b9add310c03ebd0f9078da8934109015521cfa1c39f4a5991f2831daede8c53.jpeg"
  ],
  priceDollars: 5,
  description: "Celebrate the places you and Baby love in the Natural State! Show your little one that Arkansas is where the heart is in this snuggle-worthy board book for babies and toddlers.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:26.275Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
